import { 
    apiRequest,
    perjalananDinasList,
    perjalananDinasInactive,
} from '../../../../../../services/adapters/kepegawaian/perjalananDinasService'

class IndexRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", perjalananDinasList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", perjalananDinasInactive, {
            body: query
        }, true)
    }

}

export default IndexRepository